import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  createAdminProfile,
  createDistributorProfile,
  createFillingPersonProfile,
  createMachineAdminProfile,
  createLocationAdminProfile,
  createSuperAdminProfile,
  getAdminProfile,
  getDistributorProfile,
  getFillingPersonProfile,
  getMachineAdminProfile,
  getLocationAdminProfile,
  getSuperAdminProfile,
  updateAdminProfile,
  updateDistributorProfile,
  updateFillingPersonProfile,
  updateMachineAdminProfile,
  updateLocationAdminProfile,
  updateSuperAdminProfile,
} from "data/server_apis/userProfileService";

const initialState = {
  currentProfile: null,
  status: {},
};

// Get

export const getAdminProfileThunk = createAsyncThunk(
  "adminProfile/get",
  async (id, { rejectWithValue }) => {
    try {
      return (await getAdminProfile(id)).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

export const getDistributorProfileThunk = createAsyncThunk(
  "dDistributor/get",
  async (id, { rejectWithValue }) => {
    try {
      return (await getDistributorProfile(id)).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

export const getMachineAdminProfileThunk = createAsyncThunk(
  "machineAdmin/get",
  async (id, { rejectWithValue }) => {
    try {
      return (await getMachineAdminProfile(id)).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

export const getLocationAdminProfileThunk = createAsyncThunk(
  "machineAdmin/get",
  async (id, { rejectWithValue }) => {
    try {
      return (await getLocationAdminProfile(id)).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

export const getSuperAdminProfileThunk = createAsyncThunk(
  "superAdmin/get",
  async (id, { rejectWithValue }) => {
    try {
      return (await getSuperAdminProfile(id)).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);
export const getFillingPersonProfileThunk = createAsyncThunk(
  "fillingPerson/get",
  async (id, { rejectWithValue }) => {
    try {
      return (await getFillingPersonProfile(id)).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

// Create
export const createAdminProfileThunk = createAsyncThunk(
  "adminProfile/create",
  async (data, { rejectWithValue }) => {
    try {
      return (await createAdminProfile(data)).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

export const createDistributorProfileThunk = createAsyncThunk(
  "distributorProfile/create",
  async (data, { rejectWithValue }) => {
    try {
      return (await createDistributorProfile(data)).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

export const createMachineAdminProfileThunk = createAsyncThunk(
  "machineAdminProfile/create",
  async (data, { rejectWithValue }) => {
    try {
      return (await createMachineAdminProfile(data)).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

export const createLocationAdminProfileThunk = createAsyncThunk(
  "machineAdminProfile/create",
  async (data, { rejectWithValue }) => {
    try {
      return (await createLocationAdminProfile(data)).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

export const createSuperAdminProfileThunk = createAsyncThunk(
  "superAdminProfile/create",
  async (data, { rejectWithValue }) => {
    try {
      return (await createSuperAdminProfile(data)).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);
export const createFillingPersonProfileThunk = createAsyncThunk(
  "fillingPersonProfile/create",
  async (data, { rejectWithValue }) => {
    try {
      return (await createFillingPersonProfile(data)).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

// Update
export const updateAdminProfileThunk = createAsyncThunk(
  "adminProfile/update",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      return (await updateAdminProfile(id, data)).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

export const updateDistributorProfileThunk = createAsyncThunk(
  "distributor/update",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      return (await updateDistributorProfile(id, data)).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

export const updateMachineAdminProfileThunk = createAsyncThunk(
  "machineAdmin/update",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      return (await updateMachineAdminProfile(id, data)).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

export const updateLocationAdminProfileThunk = createAsyncThunk(
  "machineAdmin/update",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      return (await updateLocationAdminProfile(id, data)).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

export const updateSuperAdminProfileThunk = createAsyncThunk(
  "superAdmin/update",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      return (await updateSuperAdminProfile(id, data)).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);
export const updateFillingPersonProfileThunk = createAsyncThunk(
  "fillingPerson/update",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      return (await updateFillingPersonProfile(id, data)).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);
const profileSlice = createSlice({
  name: "profileSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAdminProfileThunk.pending, (state, action) => {
        state.status = { loading: "get" };
      })
      .addCase(getAdminProfileThunk.rejected, (state, action) => {
        state.status = { error: "get", errorMessage: action.payload?.message };
      })
      .addCase(getAdminProfileThunk.fulfilled, (state, action) => {
        state.status = { success: "get" };
        state.currentProfile = action.payload;
      });
      builder
      .addCase(updateAdminProfileThunk.pending, (state, action) => {
        state.status = { loading: "update" };
      })
      .addCase(updateAdminProfileThunk.rejected, (state, action) => {
        state.status = { error: "update", errorMessage: action.payload?.message };
      })
      .addCase(updateAdminProfileThunk.fulfilled, (state, action) => {
        state.status = { success: "update" };
        state.currentProfile = action.payload;
      });
      builder
      .addCase(createAdminProfileThunk.pending, (state, action) => {
        state.status = { loading: "create" };
      })
      .addCase(createAdminProfileThunk.rejected, (state, action) => {
        state.status = { error: "create", errorMessage: action.payload?.message };
      })
      .addCase(createAdminProfileThunk.fulfilled, (state, action) => {
        state.status = { success: "create" };
        state.currentProfile = action.payload;
      });


      builder
      .addCase(getMachineAdminProfileThunk.pending, (state, action) => {
        state.status = { loading: "get" };
      })
      .addCase(getMachineAdminProfileThunk.rejected, (state, action) => {
        state.status = { error: "get", errorMessage: action.payload?.message };
      })
      .addCase(getMachineAdminProfileThunk.fulfilled, (state, action) => {
        state.status = { success: "get" };
        state.currentProfile = action.payload;
      });
      builder
      .addCase(updateMachineAdminProfileThunk.pending, (state, action) => {
        state.status = { loading: "update" };
      })
      .addCase(updateMachineAdminProfileThunk.rejected, (state, action) => {
        state.status = { error: "update", errorMessage: action.payload?.message };
      })
      .addCase(updateMachineAdminProfileThunk.fulfilled, (state, action) => {
        state.status = { success: "update" };
        state.currentProfile = action.payload;
      });
      builder
      .addCase(createMachineAdminProfileThunk.pending, (state, action) => {
        state.status = { loading: "create" };
      })
      .addCase(createMachineAdminProfileThunk.rejected, (state, action) => {
        state.status = { error: "create", errorMessage: action.payload?.message };
      })
      .addCase(createMachineAdminProfileThunk.fulfilled, (state, action) => {
        state.status = { success: "create" };
        state.currentProfile = action.payload;
      });


      builder
      .addCase(getSuperAdminProfileThunk.pending, (state, action) => {
        state.status = { loading: "get" };
      })
      .addCase(getSuperAdminProfileThunk.rejected, (state, action) => {
        state.status = { error: "get", errorMessage: action.payload?.message };
      })
      .addCase(getSuperAdminProfileThunk.fulfilled, (state, action) => {
        state.status = { success: "get" };
        state.currentProfile = action.payload;
      });
      builder
      .addCase(updateSuperAdminProfileThunk.pending, (state, action) => {
        state.status = { loading: "update" };
      })
      .addCase(updateSuperAdminProfileThunk.rejected, (state, action) => {
        state.status = { error: "update", errorMessage: action.payload?.message };
      })
      .addCase(updateSuperAdminProfileThunk.fulfilled, (state, action) => {
        state.status = { success: "update" };
        state.currentProfile = action.payload;
      });
      builder
      .addCase(createSuperAdminProfileThunk.pending, (state, action) => {
        state.status = { loading: "create" };
      })
      .addCase(createSuperAdminProfileThunk.rejected, (state, action) => {
        state.status = { error: "create", errorMessage: action.payload?.message };
      })
      .addCase(createSuperAdminProfileThunk.fulfilled, (state, action) => {
        state.status = { success: "create" };
        state.currentProfile = action.payload;
      });

      builder
      .addCase(getFillingPersonProfileThunk.pending, (state, action) => {
        state.status = { loading: "get" };
      })
      .addCase(getFillingPersonProfileThunk.rejected, (state, action) => {
        state.status = { error: "get", errorMessage: action.payload?.message };
      })
      .addCase(getFillingPersonProfileThunk.fulfilled, (state, action) => {
        state.status = { success: "get" };
        state.currentProfile = action.payload;
      });
      builder
      .addCase(updateFillingPersonProfileThunk.pending, (state, action) => {
        state.status = { loading: "update" };
      })
      .addCase(updateFillingPersonProfileThunk.rejected, (state, action) => {
        state.status = { error: "update", errorMessage: action.payload?.message };
      })
      .addCase(updateFillingPersonProfileThunk.fulfilled, (state, action) => {
        state.status = { success: "update" };
        state.currentProfile = action.payload;
      });
      builder
      .addCase(createFillingPersonProfileThunk.pending, (state, action) => {
        state.status = { loading: "create" };
      })
      .addCase(createFillingPersonProfileThunk.rejected, (state, action) => {
        state.status = { error: "create", errorMessage: action.payload?.message };
      })
      .addCase(createFillingPersonProfileThunk.fulfilled, (state, action) => {
        state.status = { success: "create" };
        state.currentProfile = action.payload;
      });


      builder
      .addCase(getDistributorProfileThunk.pending, (state, action) => {
        state.status = { loading: "get" };
      })
      .addCase(getDistributorProfileThunk.rejected, (state, action) => {
        state.status = { error: "get", errorMessage: action.payload?.message };
      })
      .addCase(getDistributorProfileThunk.fulfilled, (state, action) => {
        state.status = { success: "get" };
        state.currentProfile = action.payload;
      });
      builder
      .addCase(updateDistributorProfileThunk.pending, (state, action) => {
        state.status = { loading: "update" };
      })
      .addCase(updateDistributorProfileThunk.rejected, (state, action) => {
        state.status = { error: "update", errorMessage: action.payload?.message };
      })
      .addCase(updateDistributorProfileThunk.fulfilled, (state, action) => {
        state.status = { success: "update" };
        state.currentProfile = action.payload;
      });
      builder
      .addCase(createDistributorProfileThunk.pending, (state, action) => {
        state.status = { loading: "create" };
      })
      .addCase(createDistributorProfileThunk.rejected, (state, action) => {
        state.status = { error: "create", errorMessage: action.payload?.message };
      })
      .addCase(createDistributorProfileThunk.fulfilled, (state, action) => {
        state.status = { success: "create" };
        state.currentProfile = action.payload;
      });

      
  },
});

export const {} = profileSlice.actions;

export default profileSlice.reducer;
